import { Tooltip } from "@jugl-web/ui-kit";
import { FC } from "react";
import { ReactComponent as QuestionMarkIcon } from "./assets/question-mark.svg";

export type NotRemovableReasonHintProps = {
  reason: string;
};

/**
 * Question-mark tooltip for disabled "not removable" menu actions.
 */
export const NotRemovableReasonHint: FC<NotRemovableReasonHintProps> = ({
  reason,
}) => (
  <Tooltip
    delay="none"
    renderTrigger={({ ref, props }) => (
      <QuestionMarkIcon ref={ref} {...props} />
    )}
  >
    {reason}
  </Tooltip>
);
